import './featured-explore-topics.scss'

import { graphql } from 'gatsby'
import React from 'react'

import Image from '@/components/image/image'
import Link from '@/components/link/link'
import { generateUrlFromNode } from '@/utils/url'

const FeaturedExploreTopics: React.FC<
  Queries.SectionFeaturedExploreTopicFragment
> = ({ title, description, featuredTopics, background }) => {
  return (
    <div className="list-tags">
      <div className="text-with-image">
        <Image image={background} alt={title ?? ''} />
        <div className="container-text">
          <div className="container">
            <div className="row text-center justify-content-center">
              <div className="col-lg-11">
                <h2>{title}</h2>
              </div>
              <div className="col-lg-6 mt-2 description">
                <p>{description}</p>
              </div>
            </div>
            {featuredTopics && (
              <div className="row justify-content-center">
                <div className="col-lg-7">
                  <div className="grid-items">
                    {featuredTopics?.map(
                      (item) =>
                        item && (
                          <Link
                            key={`topic-${item?.slug}`}
                            to={generateUrlFromNode(item)}
                          >
                            {item?.externalName}
                          </Link>
                        )
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeaturedExploreTopics

export const query = graphql`
  fragment SectionFeaturedExploreTopic on DatoCmsFeaturedExploreTopic {
    __typename

    id
    title
    description
    background {
      gatsbyImageData(
        width: 1920
        height: 600
        imgixParams: { w: "1920", h: "600", fit: "crop", crop: "focalpoint" }
      )
    }
    featuredTopics {
      ...TopicReference
    }
  }
`
